import { useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { getApiBaseUrl } from '../../config/apiBase';

export const useCreateCampaign = () => {
    const [isLoading, setIsLoading] = useState(false);
    const { getAccessTokenSilently } = useAuth0();
    const apiUrl = getApiBaseUrl();

    const createCampaign = async (campaignData) => {
        setIsLoading(true);
        try {
            const token = await getAccessTokenSilently({
                authorizationParams: {
                    audience: process.env.REACT_APP_API_AUDIENCE,
                },
            });

            const response = await fetch(`${apiUrl}/api/campaigns`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(campaignData),
            });

            if (response.ok) {
                console.log('Campaign created successfully');
                return response.json().catch(() => null);
            } else {
                console.error('Failed to create campaign:', response.statusText);
                throw new Error(`Failed to create campaign: ${response.status}`);
            }
        } catch (error) {
            console.error('Error creating campaign:', error.message);
            throw error;
        } finally {
            setIsLoading(false);
        }
    };

    return { isLoading, createCampaign };
};
